import * as React from 'react';
import { IBaseComponentProps } from '../../types';
import styled from 'styled-components';
import { StackPanel } from '../../stack-panel';
import { IPopupProps } from '../popup-props';

interface IPopupFooterProps extends IBaseComponentProps<HTMLDivElement>, Pick<IPopupProps, 'onRenderFooter' | 'footerAlignment'> { }

const StyledStackPanel = styled(StackPanel).attrs({
    className: String('ap-popup-footer')
}) <{ $footerAlignment?: 'left' | 'center' | 'right' }>`
    position: relative;
    bottom: 0;
    height: auto;
    width: 100%;
    justify-content: ${({ $footerAlignment }) => ($footerAlignment === 'center' ? 'center' : 'flex-end')};
    padding-top: ${({ theme: { semantics: { gap } } }) => gap.xl};
    flex: none;
`;

export function PopupFooter(props: IPopupFooterProps) {
    const { onRenderFooter, className, footerAlignment = 'right' } = props;
    return onRenderFooter !== undefined ? (
        <StyledStackPanel
            className={className}
            gap='25'
            orientation="horizontal"
            $footerAlignment={footerAlignment}
            flip={footerAlignment === 'left'}>
            <>{onRenderFooter()}</>
        </StyledStackPanel>
    ) : null;
}
